/**
 * insName — display-only helpers for insurance catalog node names.
 *
 * Category names are STORED with an outline-number prefix, e.g.
 *   "1. ประกันรถยนต์", "1.1 ภาคบังคับ", "1.1.1 AC1", "1.1.1.0 XXXXXX".
 * In the narrow Miller-column cells that prefix eats the width and the real
 * name is truncated away. These helpers strip the leading "a.b.c " prefix for
 * DISPLAY ONLY — they never mutate the underlying node, store, or payloads.
 */

/**
 * Remove a leading outline number from a name, for display.
 *
 * Regex: ^\s*\d+(\.\d+)*\.?\s+
 *   ^\s*        optional leading whitespace
 *   \d+         the first number group
 *   (\.\d+)*    any number of ".n" sub-groups (1.1, 1.1.1, 1.1.1.0, …)
 *   \.?         an optional trailing dot ("1." style)
 *   \s+         REQUIRED whitespace separating the prefix from the real name
 *
 * The required trailing \s+ guarantees we only strip when an actual name
 * follows. So "1.1.1" (a bare number, no name) is left UNCHANGED rather than
 * reduced to "". As a second guard, if stripping ever yields an empty/blank
 * string we return the ORIGINAL name — this helper never returns "".
 *
 * Tolerates null/undefined → "".
 *
 * @param {string} name
 * @returns {string}
 */
export function stripOutlinePrefix(name) {
  const s = name == null ? "" : String(name);
  if (!s) return "";
  const stripped = s.replace(/^\s*\d+(\.\d+)*\.?\s+/, "");
  // Empty-result guard: never return "" — fall back to the original name.
  return stripped.trim() === "" ? s : stripped;
}

/**
 * Pick the display string for a name: stripped when the toggle is on, else the
 * original (coerced to "" when null/undefined).
 *
 * @param {string} name
 * @param {boolean} strip
 * @returns {string}
 */
export function displayName(name, strip) {
  return strip ? stripOutlinePrefix(name) : (name || "");
}
